export default __webpack_public_path__ + "static/media/attendance_filled.ee45aad9.png";